import { PhotoCapture } from '../enums';
export const PHOTO_CAPTURE_UPDATE_ATTACHMENTS_REQUEST = `${PhotoCapture.PHOTO_CAPTURE}_UPDATE_ATTACHMENTS_REQUEST`;
export const PHOTO_CAPTURE_UPDATE_ATTACHMENTS_SUCCESS = `${PhotoCapture.PHOTO_CAPTURE}_UPDATE_ATTACHMENTS_SUCCESS`;
export const PHOTO_CAPTURE_UPDATE_ATTACHMENTS_FAILURE = `${PhotoCapture.PHOTO_CAPTURE}_UPDATE_ATTACHMENTS_FAILURE`;
export const photoCapturePatchUpdateAttachmentAction = (attachmentRequest, contextId, coCode, iterationId) => ({
    type: PHOTO_CAPTURE_UPDATE_ATTACHMENTS_REQUEST,
    payload: {
        attachmentRequest,
        contextId,
        coCode,
        iterationId
    }
});
export const photoCaptureUpdateAttachmentsSuccessAction = (deletedAttachments, updatedAttachments, iterationId) => ({
    type: PHOTO_CAPTURE_UPDATE_ATTACHMENTS_SUCCESS,
    payload: {
        deletedAttachments,
        updatedAttachments,
        iterationId
    }
});
export const photoCaptureUpdateAttachmentsFailureAction = (deletedAttachments, updatedAttachments, iterationId) => ({
    type: PHOTO_CAPTURE_UPDATE_ATTACHMENTS_FAILURE,
    payload: {
        deletedAttachments,
        updatedAttachments,
        iterationId
    }
});
export const photoCaptureDeleteAttachmentsAction = (deleteAttachmentInfo, contextId, coCode, operationType) => photoCapturePatchUpdateAttachmentAction({ deleteAttachmentInfo, operationType }, contextId, coCode);
export const photoCaptureUploadAttachmentsAction = (attachmentInfo, contextId, coCode, iterationId, operationType) => photoCapturePatchUpdateAttachmentAction({ attachmentInfo, operationType }, contextId, coCode, iterationId);
//# sourceMappingURL=photoCapturePatchUpdateAttachmentAction.js.map